import React from "react";
import "./App.css";

import MonacoWindow from "./components/MonacoWindow";

import Header from "./components/Header";
import KeyExplore from "./components/KeyExplore";

import all_example_settings from "./data/default_settings.js";

import Typography from "typography";
import stAnnesTheme from "typography-theme-st-annes";
import injectFonts from "typography-inject-fonts";

const theme = stAnnesTheme;
const typography = new Typography(theme);
typography.injectStyles();
injectFonts(typography);

class App extends React.Component {
  state = {
    option_selection: "id_1",
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  getText(id) {
    let settings_dict = all_example_settings;
    let settings_text = JSON.stringify(settings_dict, null, 4);
    return settings_text;
  }

  handleChange = (event) => {
    let settings_id = event.value;
    this.setState({ option_selection: settings_id });
  };

  render() {
    let editor_text = this.getText();

    return (
      <div className="App-main-div">
        <Header />
        <div className="App-flex-container">
          <div className="App-flex-item">
            <MonacoWindow editor_contents_string={editor_text} />
          </div>
        </div>
        <KeyExplore />
      </div>
    );
  }
}

export default App;
